const template = {
    // 选择预设:templateGroup
    // 系统随机:systemRandom
    type: 'templateGroup',
    titleType: 'intelForm',
    showExpanded: true,
    useSmall: true,
    templateGroup: {
        showOuterChoose: true,
        showCheckedCon: false,
        industry: {
            value: ''
        },
        sizeControl: {
            value: {
                ratio: '16:9',
                dimension: '1140*640',
                customWidth: '',
                customHeight: ''
            }
        },
        template: {
            chooseList: [],
            originChooseList: []
        },
        sort: {
            value: 'DEFAULT'
        }
    },
    systemRandom: {
        industry: {
            value: ''
        },
        sizeControl: {
            value: {
                ratio: '16:9',
                dimension: '1140*640',
                customWidth: '',
                customHeight: ''
            }
        },
        number: {
            value: 5
        }
    }
};
const background = {
    // 上传图片:imgUploadList
    // 选择预设:bgPreset
    // 系统随机:systemRandom
    type: 'imgUploadList',
    showExpanded: true,
    imgUploadList: {
        value: []
    },
    bgPreset: {
        value: []
    },
    systemRandom: {
        value: []
    }
};
const text = {
    // 手动添加:textUploadList
    // 文案选择预设:textPreset
    // 系统随机:systemRandom
    type: 'textUploadList',
    showExpanded: true,
    textUploadList: {
        // 非B2B行业
        value: [
            //     {
            //     // 主标题
            //     mainText: '',
            //     // 副标题
            //     descText: '',
            //     // 按钮文案
            //     buttonText: '',
            //     // 其他文案
            //     otherText: ''
            // },
        ],
        // B2B行业
        b2bValue: [
            //   {
            //     // 业务点
            //     businessPointB2B: '',
            //     // 卖点1
            //     sellingPointFirst: '',
            //     // 卖点2
            //     sellingPointSecond: '',
            //     // 卖点3
            //     sellingPointThird: '',
            //     // 厂商名称
            //     manufacturerName: ''
            // }
        ]
    },
    textPreset: {
        value: []
    },
    systemRandom: {
        value: []
    }
};
const brandLogo = {
    type: 'imgUpload',
    showExpanded: true,
    imgUpload: []
};

const mainPart = {
    // 上传图片:imgUploadList
    // 智能生成:mainPartIntel
    // 选择预设:mainPartPreset
    type: 'imgUploadList',
    titleSwitch: true,
    useSmall: true,
    showExpanded: true,
    imgUploadList: {
        value: []
    },
    mainPartIntel: {
        value: {
            ratio: '16:9',
            dimension: '1140*640',
            prompt: ''
        }
    },
    mainPartPreset: {
        value: []
    }
};

export const defaultIntelFormData = {
    // 模版
    template,
    // 背景
    background,
    // 文案
    text,
    // 品牌LOGO
    brandLogo,
    // 主体
    mainPart
};

export const defaultDesignFormData = {
    // 模版
    template,
    // 背景
    background,
    // 文案
    text,
    // 主体
    mainPart,
    // 品牌LOGO
    brandLogo
};
